import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthService, AvlaRestClientService } from 'base-angular-avla';

import { StatusRegisterDTO } from '../interface/newStatusRegister';
import { PersonDTO } from '../interface/personDTO';
import {
  PayloadTemporaryUnlockDTO,
  TemporaryUnlockDTO,
} from '../interface/temporaryUnlockDTO';

@Injectable()
export class ConsultaMarkListService {
  baseUrl = '';
  // baseUrl = 'http://localhost:8086'; // For dev

  get apiMarklist(): string {
    return '/api-mark-list';
  }

  urlGenerateExcelReportAsync = `${this.baseUrl}/api-mark-list/generateExcelReportAsync`;
  urlGetExecutionProcess = `${this.baseUrl}/api-mark-list/getExecutionProcess`;
  urlFindTemporaryUnlock = `${this.baseUrl}/api-mark-list/findTemporaryUnlock`;
  urlSwitchTemporaryUnlock = `${this.baseUrl}/api-mark-list/switchTemporaryUnlock`;
  urlCreatePendingRequest = `${this.baseUrl}/api-mark-list/createRegister`;
  urlCreateStatusPerson = `${this.baseUrl}/api-mark-list/createStatusPerson`;

  loggedIn = false;
  constructor(
    private restclient: AvlaRestClientService,
    private authservice: AuthService
  ) {
    this.loggedIn = !!sessionStorage.getItem('auth_token');
  }

  getPersons() {
    return this.restclient.getList('/api-mark-list/personList/');
  }

  getReloadPage() {
    return this.restclient.getList(
      'api-mark-list/personListPaginated?limit=10&offset=0&sort=&filter='
    );
  }

  getPersonDataByDni(filter: any) {
    return this.restclient.getList(
      'api-mark-list/personListPaginated?limit=10&offset=0&sort=-sinisterDate&filter=' +
      encodeURIComponent(JSON.stringify(filter))
    );
  }

  getPersonListPaginated(
    limit: number = 10,
    offset: number = 0,
    sort: string = '',
    filter: any
  ) {
    const params = {
      limit,
      offset,
      sort,
    };

    if (filter) {
      params['filter'] = filter;
    }

    return this.restclient.getList(
      'api-mark-list/personListPaginated',
      null,
      params
    );
  }

  getStatusList(actives: boolean) {
    const queryParams = {};

    if (actives !== null || actives !== undefined) {
      queryParams['onlyActives'] = true;
    }
    return this.restclient.getList('/api-mark-list/status/', null, queryParams);
  }

  getRegisterbyIdPerson(idPerson: number) {
    return this.restclient.getList('/api-mark-list/registerFind', [], {
      idperson: idPerson,
    });
  }

  getListStatusbyIdPerson(idPerson: number) {
    return this.restclient.getList('/api-mark-list/statusPerson', [], {
      idPerson,
    });
  }

  getIncidenceList() {
    return this.restclient.getList('/api-mark-list/typeincidence');
  }

  setPerson(
    personDTO: PersonDTO,
    statusData: StatusRegisterDTO,
    countryCode: string
  ) {
    let dniProcesado: string;
    if (personDTO.dniPerson.indexOf(countryCode) == -1) {
      dniProcesado = countryCode + personDTO.dniPerson;
    } else {
      dniProcesado = personDTO.dniPerson;
      //this.datausuarios.push(ingreso);
    }
    const registroingreso = {
      person: {
        dniPerson: dniProcesado,
        idStatus: personDTO.idStatus,
        country: personDTO.country,
        countryIso: personDTO.countryIso,
        identificationType: personDTO.identificationType,
        namePerson: personDTO.namePerson,
        personType: personDTO.personType,
        registerType: personDTO.registerType,
        observation: personDTO.observation,
      },
      statusPerson: statusData,
    };
    console.log('registro ingreso', registroingreso);
    return this.restclient.post(
      `${this.baseUrl}/api-mark-list/personcreate`,
      null,
      null,
      registroingreso
    );
  }

  setRequest(
    personDTO: PersonDTO,
    statusData: StatusRegisterDTO,
    countryCode: string
  ) {
    let dniProcesado: string;
    if (personDTO.dniPerson.indexOf(countryCode) == -1) {
      dniProcesado = countryCode + personDTO.dniPerson;
    } else {
      dniProcesado = personDTO.dniPerson;
      //this.datausuarios.push(ingreso);
    }
    const registroingreso = {
      person: {
        dniPerson: dniProcesado,
        idStatus: personDTO.idStatus,
        country: personDTO.country,
        countryIso: personDTO.countryIso,
        identificationType: personDTO.identificationType,
        namePerson: personDTO.namePerson,
        personType: personDTO.personType,
        registerType: personDTO.registerType,
        observation: personDTO.observation,
      },
      statusPerson: statusData,
    };
    console.log('registro solicitud', registroingreso);
    return this.restclient.post(
      '/api-mark-list/request-person-create',
      null,
      null,
      registroingreso
    );
  }

  statuschange(personDTO: PersonDTO, username: string) {
    const statusinfo = {
      idPerson: personDTO.idPerson,
      idStatus: personDTO.idStatus,
      observation: personDTO.observation,
      userNameRegister: username,
    };
    return this.restclient.post(
      'api-mark-list/changeStatus',
      null,
      null,
      statusinfo
    );
  }

  newStatusRegister(statusRegisterDTO: StatusRegisterDTO, direct: boolean) {
    const statusinfo = {
      idPerson: statusRegisterDTO.idPerson,
      dniPerson: statusRegisterDTO.dniPerson,
      namePerson: statusRegisterDTO.namePerson,
      personType: statusRegisterDTO.personType,
      identificationType: statusRegisterDTO.identificationType,
      registrationArea: statusRegisterDTO.registrationArea,
      subArea: statusRegisterDTO.subArea,
      alertType: statusRegisterDTO.alertType,
      registerType: statusRegisterDTO.registerType,
      idStatus: statusRegisterDTO.idStatus,
      systemsBlocked: statusRegisterDTO.systemsBlocked,
      observation: statusRegisterDTO.observation,
      //userNameRegister: username,
      countSinister: 0,
      registerDate: statusRegisterDTO.registerDate,
    };

    return this.restclient.post(
      direct ? this.urlCreateStatusPerson : this.urlCreatePendingRequest,
      null,
      null,
      statusinfo
    );
  }

  createStatusPerson(statusRegisterDTO: StatusRegisterDTO) {
    const statusinfo = {
      idPerson: statusRegisterDTO.idPerson,
      dniPerson: statusRegisterDTO.dniPerson,
      namePerson: statusRegisterDTO.namePerson,
      personType: statusRegisterDTO.personType,
      identificationType: statusRegisterDTO.identificationType,
      registrationArea: statusRegisterDTO.registrationArea,
      subArea: statusRegisterDTO.subArea,
      alertType: statusRegisterDTO.alertType,
      registerType: statusRegisterDTO.registerType,
      idStatus: statusRegisterDTO.idStatus,
      systemsBlocked: statusRegisterDTO.systemsBlocked,
      observation: statusRegisterDTO.observation,
      countSinister: 0,
      registerDate: statusRegisterDTO.registerDate,
    };

    return this.restclient.post(
      'api-mark-list/createRegister',
      null,
      null,
      statusinfo
    );
  }

  getPersonbyDNI(dni: string) {
    return this.restclient.getList('/api-mark-list/personFindSiniester', [], {
      dniOrName: dni,
    });
  }

  salir() {
    return this.authservice.logout();
  }
  getuser() {
    return this.restclient.getList('/access-control/userLoggedInfo/');
  }

  //GENERACION DE EXCEL

  generateMatrixPerson(result: PersonDTO[]) {
    const matrix = [];
    for (const fila of result) {
      const filaNva = [];
      filaNva.push(fila.sinisterDate);
      filaNva.push(fila.dniPerson);
      filaNva.push(fila.namePerson);
      if (fila.personType === 'PJ') {
        filaNva.push('PERSONA JURIDICA');
      } else {
        filaNva.push('PERSONA NATURAL');
      }
      filaNva.push(fila.nameStatus);
      filaNva.push(fila.sinisterCount);
      matrix.push(filaNva);
    }
    return matrix;
  }

  generateExcelPerson(personlist: PersonDTO[]): Observable<Response> {
    const listHeader = [
      'Fecha de Siniestro',
      'DNI',
      'Nombre Completo',
      'Tipo Persona',
      'Estado',
      'N° de Sinistros',
    ];
    const content = this.generateMatrixPerson(personlist);
    const JsonForExcel = {
      sheets: [
        {
          sheetName: 'PERSONAS',
          headers: listHeader,
          content,
        },
      ],
    };
    return this.generateExcelbyJSON(JsonForExcel);
  }

  generateExcelbyJSON(Jsonforexcel: any) {
    return this.restclient.post(
      '/control-documents/generator_documents/generare_xlsx',
      [],
      {},
      Jsonforexcel
    );
  }

  // Generacion Excel desde back
  generateExcelFromBack(
    dniPerson: string,
    namePerson: string
  ): Observable<number> {
    const body = {
      dniPerson,
      namePerson,
    };
    return this.restclient
      .post(
        this.urlGenerateExcelReportAsync,
        [],
        { reportName: 'reportMarkList2' },
        body
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }
  getProcessStatus(proccessID): Observable<any> {
    const urlExecutionProcess: string =
      this.urlGetExecutionProcess + '/' + proccessID;
    return this.restclient.getSingle(urlExecutionProcess, [], null).pipe(
      map(res => {
        return res;
      }),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  updateState(parameters: any, paramsUrl: any): Observable<any> {
    return this.restclient.post(
      '/api-mark-list/editRegister',
      null,
      paramsUrl,
      parameters
    );
  }

  getTemporaryUnlockInfo(personId: number): Observable<TemporaryUnlockDTO> {
    return this.restclient.getSingle(this.urlFindTemporaryUnlock, [], {
      personId: personId,
    });
  }

  updateRequest(parameters: any, paramsUrl: any): Observable<any> {
    return this.restclient.post(
      'api-mark-list/create-pending-request-from-edit-status',
      null,
      paramsUrl,
      parameters
    );
  }

  switchTemporaryUnlockInfo(
    payload: PayloadTemporaryUnlockDTO
  ): Observable<TemporaryUnlockDTO> {
    return this.restclient.post(
      this.urlSwitchTemporaryUnlock,
      [],
      null,
      payload
    );
  }
}
